import { Action } from '@ngrx/store';
import { IntegrationProvider } from 'src/app/public/store/types/IntegrationPayment';

export enum StorePaymentMethodsActionType {
  ToggleStripe = '[storesPaymentMethods] ToggleStripe',
  ToggleStripeSuccess = '[storesPaymentMethods] ToggleStripeSuccess',
  ToggleStripeFailed = '[storesPaymentMethods] ToggleStripeFailed',
  ConnectStripe = '[storesPaymentMethods] ConnectStripe',
  DisconnectStripe = '[storesPaymentMethods] DisconnectStripe',
  DisconnectStripeSuccess = '[storesPaymentMethods] DisconnectStripeSuccess',
  DisconnectStripeFailed = '[storesPaymentMethods] DisconnectStripeFailed',

  TogglePaypal = '[storesPaymentMethods] TogglePaypal',
  TogglePaypalSuccess = '[storesPaymentMethods] TogglePaypalSuccess',
  TogglePaypalFailed = '[storesPaymentMethods] TogglePaypalFailed',
  ConnectPaypal = '[storesPaymentMethods] ConnectPaypal',
  DisconnectPaypal = '[storesPaymentMethods] DisconnectPaypal',
  DisconnectPaypalSuccess = '[storesPaymentMethods] DisconnectPaypalSuccess',
  DisconnectPaypalFailed = '[storesPaymentMethods] DisconnectPaypalFailed',
  ToggleSquare = '[storesPaymentMethods] ToggleSquare',
  ToggleSquareSuccess = '[storesPaymentMethods] ToggleSquareSuccess',
  ToggleSquareFailed = '[storesPaymentMethods] ToggleSquareFailed',

  ConnectPaymentsense = '[storesPaymentMethods] ConnectPaymentsense',
  ConnectPaymentsenseSuccess = '[storesPaymentMethods] ConnectPaymentsenseSuccess',
  ConnectPaymentsenseFailed = '[storesPaymentMethods] ConnectPaymentsenseFailed',
  ConnectRMS = '[storesPaymentMethods] ConnectRMS',
  ConnectRMSSuccess = '[storesPaymentMethods] ConnectRMSSuccess',
  ConnectRMSFailed = '[storesPaymentMethods] ConnectRMSFailed',
  ConnectJCC = '[storesPaymentMethods] ConnectJCC',
  ConnectJCCSuccess = '[storesPaymentMethods] ConnectJCCSuccess',
  ConnectJCCFailed = '[storesPaymentMethods] ConnectJCCFailed',
  DisConnectJCC = '[storesPaymentMethods] DisConnectJCC',
  DisConnectJCCSuccess = '[storesPaymentMethods] DisConnectJCCSuccess',
  DisConnectJCCFailed = '[storesPaymentMethods] DisConnectJCCFailed',
  ConnectTrustPayments = '[storesPaymentMethods] ConnectTrustPayments',
  ConnectTrustPaymentsSuccess = '[storesPaymentMethods] ConnectTrustPaymentsSuccess',
  ConnectTrustPaymentsFailed = '[storesPaymentMethods] ConnectTrustPaymentsFailed',
  DisconnectTrustPayments = '[storesPaymentMethods] DisconnectTrustPayments',
  DisconnectTrustPaymentsSuccess = '[storesPaymentMethods] DisconnectTrustPaymentsSuccess',
  DisconnectTrustPaymentsFailed = '[storesPaymentMethods] DisconnectTrustPaymentsFailed',

  ConnectVivaPayments = '[storesPaymentMethods] ConnectVivaPayments',
  ConnectVivaPaymentsSuccess = '[storesPaymentMethods] ConnectVivaPaymentsSuccess',
  ConnectVivaPaymentsFailed = '[storesPaymentMethods] ConnectVivaPaymentsFailed',
  DisconnectVivaPayments = '[storesPaymentMethods] DisconnectVivaPayments',
  DisconnectVivaPaymentsSuccess = '[storesPaymentMethods] DisconnectVivaPaymentsSuccess',
  DisconnectVivaPaymentsFailed = '[storesPaymentMethods] DisconnectVivaPaymentsFailed',

  ConnectPayabl = '[storesPaymentMethods] ConnectPayabl',
  ConnectPayablSuccess = '[storesPaymentMethods] ConnectPayablSuccess',
  ConnectPayablFailed = '[storesPaymentMethods] ConnectPayablFailed',
  DisConnectPayabl = '[storesPaymentMethods] DisConnectPayabl',
  DisConnectPayablSuccess = '[storesPaymentMethods] DisConnectPayablSuccess',
  DisConnectPayablFailed = '[storesPaymentMethods] DisConnectPayablFailed',

  ConnectGlobalPay = '[storesPaymentMethods] ConnectGlobalPay',
  ConnectGlobalPayFailed = '[storesPaymentMethods] ConnectGlobalPayFailed',
  DisConnectGlobalPay = '[storesPaymentMethods] DisConnectGlobalPay',
  DisConnectGlobalPayFailed = '[storesPaymentMethods] DisConnectGlobalPayFailed',

  ConnectMollie = '[storesPaymentMethods] ConnectMollie',
  ConnectMollieFailed = '[storesPaymentMethods] ConnectMollieFailed',
  DisConnectMollie = '[storesPaymentMethods] DisConnectMollie',
  DisConnectMollieFailed = '[storesPaymentMethods] DisConnectMollieFailed',

  ConnectFygaro = '[storesPaymentMethods] ConnectFygaro',
  ConnectFygaroFailed = '[storesPaymentMethods] ConnectFygaroFailed',
  DisConnectFygaro = '[storesPaymentMethods] DisConnectFygaro',
  DisConnectFygaroFailed = '[storesPaymentMethods] DisConnectFygaroFailed',

  ConnectEpay = '[storesPaymentMethods] ConnectEpay',
  ConnectEpayFailed = '[storesPaymentMethods] ConnectEpayFailed',
  DisConnectEpay = '[storesPaymentMethods] DisConnectEpay',
  DisConnectEpayFailed = '[storesPaymentMethods] DisConnectEpayFailed',

  ConnectApcopay = '[storesPaymentMethods] ConnectApcopay',
  ConnectApcopayFailed = '[storesPaymentMethods] ConnectApcopayFailed',
  DisConnectApcopay = '[storesPaymentMethods] DisConnectApcopay',
  DisConnectApcopayFailed = '[storesPaymentMethods] DisConnectApcopayFailed',

  ConnectHobex = '[storesPaymentMethods] ConnectHobex',
  ConnectHobexFailed = '[storesPaymentMethods] ConnectHobexFailed',
  DisconnectHobex = '[storesPaymentMethods] DisconnectHobex',
  DisconnectHobexFailed = '[storesPaymentMethods] DisconnectHobexFailed',

  ConnectRyft = '[storesPaymentMethods] ConnectRyft',
  ConnectRyftFailed = '[storesPaymentMethods] ConnectRyftFailed',
  DisconnectRyft = '[storesPaymentMethods] DisconnectRyft',
  DisconnectRyftFailed = '[storesPaymentMethods] DisconnectRyftFailed',

  ConnectAbaPayway = '[storesPaymentMethods] ConnectAbaPayway',
  ConnectAbaPaywayFailed = '[storesPaymentMethods] ConnectAbaPaywayFailed',
  DisConnectAbaPayway = '[storesPaymentMethods] DisConnectAbaPayway',
  DisConnectAbaPaywayFailed = '[storesPaymentMethods] DisConnectAbaPaywayFailed',

  ConnectRootline = '[storesPaymentMethods] ConnectRootline',
  ConnectRootlineFailed = '[storesPaymentMethods] ConnectRootlineFailed',
  DisConnectRootline = '[storesPaymentMethods] DisConnectRootline',
  DisConnectRootlineFailed = '[storesPaymentMethods] DisConnectRootlineFailed',

  ConnectSolidgate = '[storesPaymentMethods] ConnectSolidgate',
  ConnectSolidgateFailed = '[storesPaymentMethods] ConnectSolidgateFailed',
  DisconnectSolidgate = '[storesPaymentMethods] DisconnectSolidgate',
  DisconnectSolidgateFailed = '[storesPaymentMethods] DisconnectSolidgateFailed',

  ConnectEmerchantPay = '[storesPaymentMethods] ConnectEmerchantPay',
  ConnectEmerchantPayFailed = '[storesPaymentMethods] ConnectEmerchantPayFailed',
  DisConnectEmerchantPay = '[storesPaymentMethods] DisConnectEmerchantPay',
  DisConnectEmerchantPayFailed = '[storesPaymentMethods] DisConnectEmerchantPayFailed',

  ConnectIntegrationPayment = '[storesPaymentMethods] ConnectIntegrationPayment',
  ConnectIntegrationPaymentFailed = '[storesPaymentMethods] ConnectIntegrationPaymentFailed',
  DisConnectIntegrationPayment = '[storesPaymentMethods] DisConnectIntegrationPayment',
  DisConnectIntegrationPaymentFailed = '[storesPaymentMethods] DisConnectIntegrationPaymentFailed',
  IntegrationAdminPaymentNavigation = '[storesPaymentMethods] IntegrationPaymentNavigation',
  ToggleActivePayment = '[storesPaymentMethods] ToggleActivePayment',
  ToggleActivePaymentSuccess = '[storesPaymentMethods] ToggleActivePaymentSuccess',
  ToggleActivePaymentFailed = '[storesPaymentMethods] ToggleActivePaymentFailed',
}

/** @deprecated - use ToggleActivePayment instead */
export class ToggleStripe implements Action {
  readonly type = StorePaymentMethodsActionType.ToggleStripe;

  constructor(
    public readonly key: string,
    public readonly enabled: boolean,
  ) {}
}

/** @deprecated - use ToggleActivePaymentSuccess instead */
export class ToggleStripeSuccess implements Action {
  readonly type = StorePaymentMethodsActionType.ToggleStripeSuccess;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use ToggleActivePaymentFailed instead */
export class ToggleStripeFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ToggleStripeFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use ConnectIntegrationPayment instead */
export class ConnectStripe implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectStripe;

  constructor() {}
}

/** @deprecated - use DisConnectIntegrationPayment instead */
export class DisconnectStripe implements Action {
  readonly type = StorePaymentMethodsActionType.DisconnectStripe;

  constructor() {}
}

/** @deprecated - use UpdateStoreSettingsSuccess instead */
export class DisconnectStripeSuccess implements Action {
  readonly type = StorePaymentMethodsActionType.DisconnectStripeSuccess;

  constructor() {}
}

/** @deprecated - use DisConnectIntegrationPaymentFailed instead */
export class DisconnectStripeFailed implements Action {
  readonly type = StorePaymentMethodsActionType.DisconnectStripeFailed;

  constructor(public readonly errorMessages: string[]) {}
}

// Paypal integration
/** @deprecated - use ToggleActivePayment instead */
export class TogglePaypal implements Action {
  readonly type = StorePaymentMethodsActionType.TogglePaypal;

  constructor(public readonly enabled: boolean) {}
}

/** @deprecated - use ToggleActivePaymentSuccess instead */
export class TogglePaypalSuccess implements Action {
  readonly type = StorePaymentMethodsActionType.TogglePaypalSuccess;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use ToggleActivePaymentFailed instead */
export class TogglePaypalFailed implements Action {
  readonly type = StorePaymentMethodsActionType.TogglePaypalFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use ConnectIntegrationPayment instead */
export class ConnectPaypal implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectPaypal;

  constructor() {}
}

/** @deprecated - use DisConnectIntegrationPayment instead */
export class DisconnectPaypal implements Action {
  readonly type = StorePaymentMethodsActionType.DisconnectPaypal;

  constructor() {}
}

/** @deprecated - use UpdateStoreSettingsSuccess instead */
export class DisconnectPaypalSuccess implements Action {
  readonly type = StorePaymentMethodsActionType.DisconnectPaypalSuccess;

  constructor() {}
}

/** @deprecated - use DisConnectIntegrationPaymentFailed instead */
export class DisconnectPaypalFailed implements Action {
  readonly type = StorePaymentMethodsActionType.DisconnectPaypalFailed;

  constructor(public readonly errorMessages: string[]) {}
}

// Suqare integration
/** @deprecated - use ToggleActivePayment instead */
export class ToggleSquare implements Action {
  readonly type = StorePaymentMethodsActionType.ToggleSquare;

  constructor(public readonly enabled: boolean) {}
}

/** @deprecated - use ToggleActivePaymentSuccess instead */
export class ToggleSquareSuccess implements Action {
  readonly type = StorePaymentMethodsActionType.ToggleSquareSuccess;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use ToggleActivePaymentFailed instead */
export class ToggleSquareFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ToggleSquareFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use ConnectIntegrationPayment instead */
export class ConnectPaymentsense implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectPaymentsense;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use UpdateStoreSettingsSuccess instead */
export class ConnectPaymentsenseSuccess implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectPaymentsenseSuccess;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use ConnectIntegrationPaymentFailed instead */
export class ConnectPaymentsenseFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectPaymentsenseFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use ConnectIntegrationPayment instead */
export class ConnectRMS implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectRMS;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use UpdateStoreSettingsSuccess instead */
export class ConnectRMSSuccess implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectRMSSuccess;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use ConnectIntegrationPaymentFailed instead */
export class ConnectRMSFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectRMSFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use ConnectIntegrationPayment instead */
export class ConnectJCC implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectJCC;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use UpdateStoreSettingsSuccess instead */
export class ConnectJCCSuccess implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectJCCSuccess;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use ConnectIntegrationPaymentFailed instead */
export class ConnectJCCFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectJCCFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use DisConnectIntegrationPayment instead */
export class DisConnectJCC implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectJCC;

  constructor() {}
}

/** @deprecated - use UpdateStoreSettingsSuccess instead */
export class DisConnectJCCSuccess implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectJCCSuccess;

  constructor() {}
}

/** @deprecated - use DisConnectIntegrationPaymentFailed instead */
export class DisConnectJCCFailed implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectJCCFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use ConnectIntegrationPayment instead */
export class ConnectTrustPayments implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectTrustPayments;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use UpdateStoreSettingsSuccess instead */
export class ConnectTrustPaymentsSuccess implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectTrustPaymentsSuccess;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use ConnectIntegrationPaymentFailed instead */
export class ConnectTrustPaymentsFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectTrustPaymentsFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use DisConnectIntegrationPayment instead */
export class DisconnectTrustPayments implements Action {
  readonly type = StorePaymentMethodsActionType.DisconnectTrustPayments;

  constructor() {}
}

/** @deprecated - use UpdateStoreSettingsSuccess instead */
export class DisconnectTrustPaymentsSuccess implements Action {
  readonly type = StorePaymentMethodsActionType.DisconnectTrustPaymentsSuccess;

  constructor() {}
}

/** @deprecated - use DisConnectIntegrationPaymentFailed instead */
export class DisconnectTrustPaymentsFailed implements Action {
  readonly type = StorePaymentMethodsActionType.DisconnectTrustPaymentsFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use ConnectIntegrationPayment instead */
export class ConnectVivaPayments implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectVivaPayments;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use UpdateStoreSettingsSuccess instead */
export class ConnectVivaPaymentsSuccess implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectVivaPaymentsSuccess;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use ConnectIntegrationPaymentFailed instead */
export class ConnectVivaPaymentsFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectVivaPaymentsFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use DisConnectIntegrationPayment instead */
export class DisconnectVivaPayments implements Action {
  readonly type = StorePaymentMethodsActionType.DisconnectVivaPayments;

  constructor() {}
}

/** @deprecated - use UpdateStoreSettingsSuccess instead */
export class DisconnectVivaPaymentsSuccess implements Action {
  readonly type = StorePaymentMethodsActionType.DisconnectVivaPaymentsSuccess;

  constructor() {}
}

/** @deprecated - use DisConnectIntegrationPaymentFailed instead */
export class DisconnectVivaPaymentsFailed implements Action {
  readonly type = StorePaymentMethodsActionType.DisconnectVivaPaymentsFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use ConnectIntegrationPayment instead */
export class ConnectPayabl implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectPayabl;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use UpdateStoreSettingsSuccess instead */
export class ConnectPayablSuccess implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectPayablSuccess;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use ConnectIntegrationPaymentFailed instead */
export class ConnectPayablFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectPayablFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use DisConnectIntegrationPayment instead */
export class DisConnectPayabl implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectPayabl;

  constructor() {}
}

/** @deprecated - use UpdateStoreSettingsSuccess instead */
export class DisConnectPayablSuccess implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectPayablSuccess;

  constructor() {}
}

/** @deprecated - use DisConnectIntegrationPaymentFailed instead */
export class DisConnectPayablFailed implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectPayablFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use ConnectIntegrationPayment instead */
export class ConnectGlobalPay implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectGlobalPay;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use ConnectIntegrationPaymentFailed instead */
export class ConnectGlobalPayFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectGlobalPayFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use DisConnectIntegrationPayment instead */
export class DisConnectGlobalPay implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectGlobalPay;

  constructor() {}
}

/** @deprecated - use DisConnectIntegrationPaymentFailed instead */
export class DisConnectGlobalPayFailed implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectGlobalPayFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use ConnectIntegrationPayment instead */
export class ConnectMollie implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectMollie;

  constructor() {}
}

/** @deprecated - use ConnectIntegrationPaymentFailed instead */
export class ConnectMollieFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectMollieFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use DisConnectIntegrationPayment instead */
export class DisConnectMollie implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectMollie;

  constructor() {}
}

/** @deprecated - use DisConnectIntegrationPaymentFailed instead */
export class DisConnectMollieFailed implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectMollieFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use ConnectIntegrationPayment instead */
export class ConnectFygaro implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectFygaro;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use ConnectIntegrationPaymentFailed instead */
export class ConnectFygaroFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectFygaroFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use DisConnectIntegrationPayment instead */
export class DisConnectFygaro implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectFygaro;

  constructor() {}
}

/** @deprecated - use DisConnectIntegrationPaymentFailed instead */
export class DisConnectFygaroFailed implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectFygaroFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use ConnectIntegrationPayment instead */
export class ConnectEpay implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectEpay;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use ConnectIntegrationPaymentFailed instead */
export class ConnectEpayFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectEpayFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use DisConnectIntegrationPayment instead */
export class DisConnectEpay implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectEpay;

  constructor() {}
}

/** @deprecated - use DisConnectIntegrationPaymentFailed instead */
export class DisConnectEpayFailed implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectEpayFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use ConnectIntegrationPayment instead */
export class ConnectApcopay implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectApcopay;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use ConnectIntegrationPaymentFailed instead */
export class ConnectApcopayFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectApcopayFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use DisConnectIntegrationPayment instead */
export class DisConnectApcopay implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectApcopay;

  constructor() {}
}

/** @deprecated - use DisConnectIntegrationPaymentFailed instead */
export class DisConnectApcopayFailed implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectApcopayFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use ConnectIntegrationPayment instead */
export class ConnectHobex implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectHobex;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use ConnectIntegrationPaymentFailed instead */
export class ConnectHobexFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectHobexFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use DisConnectIntegrationPayment instead */
export class DisconnectHobex implements Action {
  readonly type = StorePaymentMethodsActionType.DisconnectHobex;

  constructor() {}
}

/** @deprecated - use DisConnectIntegrationPaymentFailed instead */
export class DisconnectHobexFailed implements Action {
  readonly type = StorePaymentMethodsActionType.DisconnectHobexFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use ConnectIntegrationPayment instead */
export class ConnectRyft implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectRyft;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use ConnectIntegrationPaymentFailed instead */
export class ConnectRyftFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectRyftFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use DisConnectIntegrationPayment instead */
export class DisconnectRyft implements Action {
  readonly type = StorePaymentMethodsActionType.DisconnectRyft;

  constructor() {}
}

/** @deprecated - use DisConnectIntegrationPaymentFailed instead */
export class DisconnectRyftFailed implements Action {
  readonly type = StorePaymentMethodsActionType.DisconnectRyftFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use ConnectIntegrationPayment instead */
export class ConnectAbaPayway implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectAbaPayway;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use ConnectIntegrationPaymentFailed instead */
export class ConnectAbaPaywayFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectAbaPaywayFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use DisConnectIntegrationPayment instead */
export class DisConnectAbaPayway implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectAbaPayway;

  constructor() {}
}

/** @deprecated - use DisConnectIntegrationPaymentFailed instead */
export class DisConnectAbaPaywayFailed implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectAbaPaywayFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use ConnectIntegrationPayment instead */
export class ConnectRootline implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectRootline;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use ConnectIntegrationPaymentFailed instead */
export class ConnectRootlineFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectRootlineFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use DisConnectIntegrationPayment instead */
export class DisConnectRootline implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectRootline;

  constructor() {}
}

/** @deprecated - use DisConnectIntegrationPaymentFailed instead */
export class DisConnectRootlineFailed implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectRootlineFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use ConnectIntegrationPayment instead */
export class ConnectSolidgate implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectSolidgate;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use ConnectIntegrationPaymentFailed instead */
export class ConnectSolidgateFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectSolidgateFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use DisConnectIntegrationPayment instead */
export class DisConnectSolidgate implements Action {
  readonly type = StorePaymentMethodsActionType.DisconnectSolidgate;

  constructor() {}
}

/** @deprecated - use DisConnectIntegrationPaymentFailed instead */
export class DisConnectSolidgateFailed implements Action {
  readonly type = StorePaymentMethodsActionType.DisconnectSolidgateFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use ConnectIntegrationPayment instead */
export class ConnectEmerchantPay implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectEmerchantPay;

  constructor(public readonly settings: { [key: string]: any }) {}
}

/** @deprecated - use ConnectIntegrationPaymentFailed instead */
export class ConnectEmerchantPayFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectEmerchantPayFailed;

  constructor(public readonly errorMessages: string[]) {}
}

/** @deprecated - use DisConnectIntegrationPayment instead */
export class DisConnectEmerchantPay implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectEmerchantPay;

  constructor() {}
}

/** @deprecated - use DisConnectIntegrationPaymentFailed instead */
export class DisConnectEmerchantPayFailed implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectEmerchantPayFailed;

  constructor(public readonly errorMessages: string[]) {}
}

export class ConnectIntegrationPayment implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectIntegrationPayment;

  constructor(
    public readonly provider: IntegrationProvider,
    public readonly settings: { [key: string]: any },
  ) {}
}

export class ConnectIntegrationPaymentFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ConnectIntegrationPaymentFailed;

  constructor(public readonly errorMessages: string[]) {}
}

export class DisConnectIntegrationPayment implements Action {
  readonly type = StorePaymentMethodsActionType.DisConnectIntegrationPayment;

  constructor(public readonly provider: IntegrationProvider) {}
}

export class DisConnectIntegrationPaymentFailed implements Action {
  readonly type =
    StorePaymentMethodsActionType.DisConnectIntegrationPaymentFailed;

  constructor(public readonly errorMessages: string[]) {}
}

export class IntegrationAdminPaymentNavigation implements Action {
  readonly type =
    StorePaymentMethodsActionType.IntegrationAdminPaymentNavigation;
  constructor(public readonly navigationUrl: string) {}
}

export class ToggleActivePayment implements Action {
  readonly type = StorePaymentMethodsActionType.ToggleActivePayment;

  constructor(
    public readonly key: string,
    public readonly enabled: boolean,
  ) {}
}

export class ToggleActivePaymentSuccess implements Action {
  readonly type = StorePaymentMethodsActionType.ToggleActivePaymentSuccess;

  constructor(public readonly settings: { [key: string]: any }) {}
}

export class ToggleActivePaymentFailed implements Action {
  readonly type = StorePaymentMethodsActionType.ToggleActivePaymentFailed;

  constructor(public readonly errorMessages: string[]) {}
}

export type StorePaymentMethodsAction =
  | ToggleStripe
  | ToggleStripeFailed
  | ToggleStripeSuccess
  | ConnectStripe
  | DisconnectStripe
  | DisconnectStripeFailed
  | DisconnectStripeSuccess
  | TogglePaypal
  | TogglePaypalFailed
  | TogglePaypalSuccess
  | ConnectPaypal
  | DisconnectPaypal
  | DisconnectPaypalFailed
  | DisconnectPaypalSuccess
  | ToggleSquare
  | ToggleSquareFailed
  | ToggleSquareSuccess
  | ConnectPaymentsense
  | ConnectPaymentsenseSuccess
  | ConnectPaymentsenseFailed
  | ConnectRMS
  | ConnectRMSSuccess
  | ConnectRMSFailed
  | ConnectJCC
  | ConnectJCCSuccess
  | ConnectJCCFailed
  | DisConnectJCC
  | DisConnectJCCSuccess
  | DisConnectJCCFailed
  | ConnectTrustPayments
  | ConnectTrustPaymentsSuccess
  | ConnectTrustPaymentsFailed
  | DisconnectTrustPayments
  | DisconnectTrustPaymentsSuccess
  | DisconnectTrustPaymentsFailed
  | ConnectVivaPayments
  | ConnectVivaPaymentsSuccess
  | ConnectVivaPaymentsFailed
  | DisconnectVivaPayments
  | DisconnectVivaPaymentsSuccess
  | DisconnectVivaPaymentsFailed
  | ConnectPayabl
  | ConnectPayablSuccess
  | ConnectPayablFailed
  | DisConnectPayabl
  | DisConnectPayablSuccess
  | DisConnectPayablFailed
  | ConnectGlobalPay
  | ConnectGlobalPayFailed
  | DisConnectGlobalPay
  | DisConnectGlobalPayFailed
  | ConnectMollie
  | ConnectMollieFailed
  | DisConnectMollie
  | DisConnectMollieFailed
  | ConnectFygaro
  | ConnectFygaroFailed
  | DisConnectFygaro
  | DisConnectFygaroFailed
  | ConnectEpay
  | ConnectEpayFailed
  | DisConnectEpay
  | DisConnectEpayFailed
  | ConnectApcopay
  | ConnectApcopayFailed
  | DisConnectApcopay
  | DisConnectApcopayFailed
  | ConnectHobex
  | ConnectHobexFailed
  | DisconnectHobex
  | DisconnectHobexFailed
  | ConnectRyft
  | ConnectRyftFailed
  | DisconnectRyft
  | DisconnectRyftFailed
  | ConnectAbaPayway
  | ConnectAbaPaywayFailed
  | DisConnectAbaPayway
  | DisConnectAbaPaywayFailed
  | ConnectRootline
  | ConnectRootlineFailed
  | DisConnectRootline
  | DisConnectRootlineFailed
  | ConnectSolidgate
  | ConnectSolidgateFailed
  | DisConnectSolidgate
  | DisConnectSolidgateFailed
  | ConnectEmerchantPay
  | ConnectEmerchantPayFailed
  | DisConnectEmerchantPay
  | DisConnectEmerchantPayFailed
  | ConnectIntegrationPayment
  | ConnectIntegrationPaymentFailed
  | DisConnectIntegrationPayment
  | DisConnectIntegrationPaymentFailed
  | IntegrationAdminPaymentNavigation
  | ToggleActivePayment
  | ToggleActivePaymentSuccess
  | ToggleActivePaymentFailed;
